module.exports = "<ion-content>\n  \n  \n  <p>\n    track-distance works!\n  </p>\n  \n</ion-content>"